import { ReactNode } from 'react';

import { Typography } from '@mui/material';

function InstanceTypeName({ children }: { children: ReactNode }) {
  return <Typography variant="body1">{children}</Typography>;
}

export { InstanceTypeName };
